// Avatars in this design are always initials on a tinted background — no
// photography. Tints are derived from the name so a person keeps the same colour
// everywhere, and every hue sits at the same lightness/chroma as the design's
// accents (L≈0.52 / C≈0.13 for ink, a light wash behind it).

const HUES = [262, 155, 55, 25, 300, 200, 100, 330]

function hueFor(seed: string): number {
  let h = 0
  for (let i = 0; i < seed.length; i += 1) h = (h * 31 + seed.charCodeAt(i)) >>> 0
  return HUES[h % HUES.length]!
}

export function tint(seed: string | null | undefined): { background: string; color: string } {
  const hue = hueFor((seed ?? '?').toLowerCase())
  return {
    background: `oklch(0.94 0.045 ${hue})`,
    color: `oklch(0.45 0.12 ${hue})`,
  }
}

/** Semantic tone → the design's tint pair. */
export const TONES = {
  positive: { background: 'var(--positive-tint)', color: 'var(--positive)' },
  warning: { background: 'var(--warning-tint)', color: 'var(--warning)' },
  danger: { background: 'var(--danger-tint)', color: 'var(--danger)' },
  accent: { background: 'var(--accent-tint)', color: 'var(--accent)' },
  neutral: { background: 'oklch(0.96 0.004 265)', color: 'var(--ink-2)' },
} as const

export type Tone = keyof typeof TONES

/** Stage swatch colour on the kanban. Terminal stages read as done or dead;
 *  everything mid-funnel steps through the accent hues. */
export function stageColor(key: string, terminal: boolean): string {
  if (['funded', 'closed', 'post_closing', 'purchased', 'servicing', 'in_shipping'].includes(key))
    return 'var(--positive)'
  if (['denied', 'withdrawn', 'not_accepted', 'incomplete', 'rescinded', 'pre_deny'].includes(key))
    return 'var(--danger)'
  if (terminal) return 'var(--ink-4)'
  if (key.includes('submission') || key === 'approved') return 'var(--stage-purple)'
  if (['processing', 'suspended', 'condition_submission'].includes(key)) return 'var(--warning)'
  if (key === 'clear_to_close') return 'var(--positive)'
  return 'var(--accent)'
}
